import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { WinnerIdentityHeader } from '@/components/market/winner-identity-header';
import { WinnerStatusBadges } from '@/components/market/winner-status-badges';
import type { WinnerVM } from './derive';
interface WinnerHeaderProps {
  winner: WinnerVM;
  marketPubkey: string;
}

/** Winner-tab identity mirrors the tradable winner card. */
export function WinnerHeader(t0) {
  const $ = _c(13);
  const {
    winner,
    marketPubkey
  } = t0;
  const t = useTranslations("market.resolvedPanel");
  const t1 = winner.index;
  const t2 = winner.label;
  const t3 = winner.imageUrl;
  const t4 = winner.imageNsfw;
  let t5;
  if ($[0] !== t || $[1] !== winner.label) {
    t5 = t("winnerImageAlt", {
      label: winner.label
    });
    $[0] = t;
    $[1] = winner.label;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== winner.ticker) {
    t6 = <WinnerStatusBadges ticker={winner.ticker} />;
    $[3] = winner.ticker;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== marketPubkey || $[6] !== t5 || $[7] !== t6 || $[8] !== winner.imageNsfw || $[9] !== winner.imageUrl || $[10] !== winner.index || $[11] !== winner.label) {
    t7 = <WinnerIdentityHeader marketPubkey={marketPubkey} outcomeIndex={t1} name={t2} imageUrl={t3} imageNsfw={t4} imageAlt={t5} status={t6} showSettledBadge={true} />;
    $[5] = marketPubkey;
    $[6] = t5;
    $[7] = t6;
    $[8] = winner.imageNsfw;
    $[9] = winner.imageUrl;
    $[10] = winner.index;
    $[11] = winner.label;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}